import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Div = styled.div`
  display: flex;
  flex-direction: column;

  .green {
    color: #06c86b;
  }
`;
